import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import axiosInstance from '../axiosInstance';
import DarkElegance from './landing/DarkElegance';

const LandingPage = () => {
  const user = useSelector((state) => state.auth.auth?.user || state.auth.user);
  const [landingData, setLandingData] = useState(null);

  useEffect(() => {
    axiosInstance.get('/landing-page/content')
      .then(res => {
        if (res.data.success && res.data.data) {
          setLandingData(res.data.data);
        }
      })
      .catch(() => {
        console.warn('Landing page API unavailable, using defaults');
      });
  }, []);

  if (user) {
    return <Navigate to="/home" replace />;
  }

  const content = landingData?.content || null;

  return <DarkElegance content={content} />;
};

export default LandingPage;
